import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    message: {
      fontFamily: 'Roboto',
      fontSize: 14,
      fontWeight: 500,
    },
    messageAction: {
      color: palette.white,
      background: palette.messageGreen,
      fontSize: 12,
    },
    actionButton: {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      textTransform: 'uppercase',
      fontSize: 12,
      fontWeight: 500,
      padding: 8,
      cursor: 'pointer',
      color: palette.white,
    },
  });
